import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mold-header table_90 f-12"
};
const _hoisted_2 = {
  class: "table_90 f-12"
};
const _hoisted_3 = {
  class: "table_90 f-12"
};
const _hoisted_4 = {
  class: "mold-header table_90 f-12"
};
const _hoisted_5 = {
  class: "click-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_el_button = _resolveComponent("el-button");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_vxe_button = _resolveComponent("vxe-button");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_vxe_textarea = _resolveComponent("vxe-textarea");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      inline: true,
      model: $data.formInline,
      rules: $data.rules,
      class: "demo-form-inline"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [$data.formInline.dotype != 'add' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 0,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具编号",
            "label-width": "78px",
            prop: "number"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.formInline.matrix_sn), 1)]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具名称",
            prop: "matrix_title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.matrix_title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formInline.matrix_title = $event),
              placeholder: "模具名称",
              maxlength: "255",
              style: {
                "width": "480px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_cache[18] || (_cache[18] = _createElementVNode("h2", null, [_createTextVNode("模具关联半成品管理"), _createElementVNode("span", {
    style: {
      "font-size": "0.5em",
      "font-weight": "500"
    }
  }, "（此处只关联直接由模具生产的物料信息）")], -1)), _createVNode(_component_vxe_table, {
    border: "",
    data: $data.tableColumn,
    ref: "xTable",
    "edit-config": {
      trigger: 'click',
      mode: 'row'
    },
    "row-id": "keyid",
    "edit-rules": $data.rules
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      field: "produce_sn",
      title: "半成品物料编码",
      "edit-render": {},
      prop: "produce_sn"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.produce_sn,
        "onUpdate:modelValue": $event => row.produce_sn = $event,
        onBlur: $event => $options.getMaterial(row.produce_sn, row.keyid),
        type: "text"
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "id",
      title: "id",
      visible: false
    }), _createVNode(_component_vxe_column, {
      field: "produce_titile",
      title: "半成品物料名称"
    }), _createVNode(_component_vxe_column, {
      field: "produce_sku",
      title: "半成品物料规格型号（sku）"
    }), _createVNode(_component_vxe_column, {
      field: "holes_num",
      title: "模具穴数",
      "edit-render": {},
      prop: "holes_num"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.holes_num,
        "onUpdate:modelValue": $event => row.holes_num = $event,
        modelModifiers: {
          number: true
        },
        onBlur: $event => $options.getHolesNum(row.holes_num, row.keyid, 1),
        type: "text",
        maxlength: "7"
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "capacity_num",
      title: "模具产能（每小时）",
      "edit-render": {}
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.capacity_num,
        "onUpdate:modelValue": $event => row.capacity_num = $event,
        onBlur: $event => $options.getHolesNum(row.capacity_num, row.keyid, 2),
        type: "text",
        maxlength: "7"
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "operation",
      title: "操作",
      width: "100"
    }, {
      default: _withCtx(({
        row
      }) => [_createVNode(_component_el_button, {
        size: "mini",
        onClick: $event => $options.removeRow(row),
        status: "danger"
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("删除行")])),
        _: 2,
        __: [16]
      }, 1032, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data", "edit-rules"]), _createVNode(_component_vxe_button, {
    onClick: _cache[1] || (_cache[1] = $event => $options.insertEvent(-1)),
    class: "mold-header",
    status: "primary"
  }, {
    default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("新增行")])),
    _: 1,
    __: [17]
  })]), _createElementVNode("div", _hoisted_3, [_cache[20] || (_cache[20] = _createElementVNode("h2", {
    style: {
      "display": "contents"
    }
  }, [_createTextVNode("关联成品型号"), _createElementVNode("span", {
    style: {
      "font-size": "0.5em",
      "font-weight": "500"
    }
  }, "（此处只关联上方半成品可生产的成品信息）")], -1)), _createVNode(_component_el_button, {
    type: "text",
    style: {
      "margin-left": "200px"
    },
    size: "small",
    onClick: $options.getProductList
  }, {
    default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("获取成品信息")])),
    _: 1,
    __: [19]
  }, 8, ["onClick"]), _createVNode(_component_vxe_table, {
    border: "",
    data: $data.productList
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      field: "product_sn",
      title: "成品物料编码"
    }), _createVNode(_component_vxe_column, {
      field: "id",
      title: "id",
      visible: false
    }), _createVNode(_component_vxe_column, {
      field: "product_name",
      title: "成品物料名称"
    }), _createVNode(_component_vxe_column, {
      field: "product_sku",
      title: "成品物料规格型号（sku）"
    })]),
    _: 1
  }, 8, ["data"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      inline: true,
      model: $data.formInline,
      class: "demo-form-inline"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具类型",
            "label-width": "85px",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formInline.type = $event),
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.matrix_type, (item, key, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: item,
                  value: index
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "有无复制模",
            "label-width": "85px",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.is_copy_matrix,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formInline.is_copy_matrix = $event),
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.is_copy_matrixs, (item, key, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: item,
                  value: index
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具费用",
            "label-width": "115px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.cost_price,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formInline.cost_price = $event),
              placeholder: "模具费用",
              onkeyup: "this.value=this.value.match(/\\d+\\.?\\d{0,2}/)",
              onafterpaste: "this.value=this.value.match(/\\d+\\.?\\d{0,2}/)",
              maxlength: "7",
              style: {
                "width": "220px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具费用返还标准(万次)"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.return_standard,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formInline.return_standard = $event),
              placeholder: "模具费用返还标准(万次)",
              onkeyup: "this.value=this.value.match(/\\d+\\.?\\d{0,2}/)",
              onafterpaste: "this.value=this.value.match(/\\d+\\.?\\d{0,2}/)",
              maxlength: "7"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "申请开模时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formInline.matrix_start,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formInline.matrix_start = $event),
              type: "date",
              placeholder: "请选择申请开模时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "开模完成时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formInline.matrix_finish,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formInline.matrix_finish = $event),
              type: "date",
              placeholder: "请选择开模完成时间",
              style: {}
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具设计寿命(万次)"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.matrix_life,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.formInline.matrix_life = $event),
              placeholder: "模具设计寿命(万次)",
              onkeyup: "this.value=this.value.match(/\\d+\\.?\\d{0,2}/)",
              onafterpaste: "this.value=this.value.match(/\\d+\\.?\\d{0,2}/)",
              maxlength: "7",
              style: {
                "width": "220px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具状态",
            "label-width": "140px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.status,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.formInline.status = $event),
              filterable: "",
              placeholder: "请选择",
              style: {
                "width": "92%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.matrix_status, (item, key, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: item,
                  value: index
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "开模申请组织",
            "label-width": "95px",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.org_id,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.formInline.org_id = $event),
              onChange: $options.changeOrg,
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.uc_orgs, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.org_name,
                  value: item.org_id,
                  key: index + '111'
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "开模申请部门",
            "label-width": "95px",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: $data.formInline.dept_code,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.formInline.dept_code = $event),
              onChange: $options.changeDept,
              options: $data.depts,
              props: {
                expandTrigger: 'hover',
                value: 'dept_code',
                label: 'dept_name',
                children: 'children',
                checkStrictly: true
              }
            }, null, 8, ["modelValue", "onChange", "options"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "开模申请人",
            "label-width": "115px",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.matrix_apply,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.formInline.matrix_apply = $event),
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.uc_staffs, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.staff_name,
                  value: item.staff_name,
                  key: index + '111'
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具供应商",
            "label-width": "85px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.supplier,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.formInline.supplier = $event),
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.uc_suppliers, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.sup_name,
                  value: item.sup_name,
                  key: index + '222'
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "物料生产供应商(模具所在地）",
            "label-width": "118px",
            aligh: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.produc_supplier,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.formInline.produc_supplier = $event),
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.uc_suppliers, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.sup_name,
                  value: item.sup_name,
                  key: index + '333'
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具管理协议",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              class: "upload-demo",
              action: $options.api_upload_url,
              "before-upload": $options.onBeforeUpload,
              "on-change": $options.handleChange,
              "on-success": $options.handleAvatarSuccess,
              "on-exceed": $options.cickCtips,
              "on-preview": $options.getDownload,
              name: "file",
              "file-list": $data.fileList,
              "with-credentials": true,
              limit: 1,
              multiple: false,
              accept: ".jpg,.png,.pdf"
            }, {
              tip: _withCtx(() => _cache[22] || (_cache[22] = [_createElementVNode("div", {
                class: "el-upload__tip"
              }, "上传文件支持：jpg/png/pdf 最大限制上传： 10M", -1)])),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "primary"
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("i", {
                  class: "el-icon-plus"
                }, null, -1), _createTextVNode("上传协议")])),
                _: 1,
                __: [21]
              })]),
              _: 1
            }, 8, ["action", "before-upload", "on-change", "on-success", "on-exceed", "on-preview", "file-list"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "备注",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_textarea, {
              modelValue: $data.formInline.remark,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.formInline.remark = $event),
              placeholder: "显示字数统计",
              rows: "4",
              maxlength: "255",
              "show-word-count": "",
              style: {
                "width": "1500px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $options.onSubmit,
          class: "btn-save"
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("保存")])),
          _: 1,
          __: [23]
        }, 8, ["onClick"])])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  })])]);
}